export type Challenge = 'relaxed' | 'balanced' | 'challenging';
export const challengeVersion = 'challenge-2';
export const isChallenge = (value: unknown): value is Challenge => typeof value === 'string' && ['relaxed', 'balanced', 'challenging'].includes(value);
export function challengeCount(challenge: Challenge, rows: number, columns: number): number {
  const baseline = Math.min(20, Math.max(8, Math.floor(rows * columns / 9)));
  return challenge === 'relaxed' ? Math.max(5, Math.ceil(baseline * .7)) : challenge === 'challenging' ? Math.min(28, Math.ceil(baseline * 1.25)) : baseline;
}
export function challengeWords(words: string[], challenge: Challenge, maximum: number, count: number): string[] {
  const eligible = words.filter(word => [...word].length >= 3 && [...word].length <= maximum);
  if (challenge === 'relaxed') {
    const short = eligible.filter(word => [...word].length <= 6);
    return short.length ? short : eligible;
  }
  if (challenge === 'challenging') {
    let minimum = Math.min(6, maximum);
    while (minimum > 3 && eligible.filter(word => [...word].length >= minimum).length < Math.min(count, eligible.length)) minimum--;
    return eligible.filter(word => [...word].length >= minimum);
  }
  return eligible;
}

export function commonnessWords(words: string[], ranks: ReadonlyMap<string, number> | undefined, challenge: Challenge, count: number): string[] {
  if (!ranks?.size) return words;
  const ranked = words.filter(word => ranks.has(word));
  const preferred = ranked.filter(word => {
    const bucket = ranks.get(word)!;
    return challenge === 'relaxed' ? bucket <= 500 : challenge === 'balanced' ? bucket <= 600 : bucket >= 500 && bucket <= 700;
  });
  return preferred.length >= count ? preferred : ranked.length ? ranked : words;
}
